import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import loanEnqService from "./loanEnqService";

export const createLoanEnquiry = createAsyncThunk(
  "loan/createLoanEnquiry",
  async (enquiryData, thunkAPI) => {
    try {
      return await loanEnqService.createLoanEnquiry(enquiryData);
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  loanEnquiry: null,
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const loanEnqSlice = createSlice({
  name: "loanEnquiry",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createLoanEnquiry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createLoanEnquiry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.loanEnquiry = action.payload;
      })
      .addCase(createLoanEnquiry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(resetState, () => initialState);
  },
});

export default loanEnqSlice.reducer;
